import { Text, Logo } from '@kanda-libs/ks-design-library';

const ViewComponent = ({}) => (
  <div className="flex flex-row">
    <Text
      text="Powered by"
      className="text-12-18-em text-neutral-500 mr-2 my-auto"
    />
    <Logo width={61} height={18} className="my-auto" />
  </div>
);

ViewComponent.displayName = 'PoweredBy-view';

export default ViewComponent;
